import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=51671004&scoped=true&lang=pug&"
import script from "./ReportsList.vue?vue&type=script&lang=ts&"
export * from "./ReportsList.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsList.vue?vue&type=style&index=0&id=51671004&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51671004",
  null
  
)

export default component.exports